var map = {
	"./Galvanized GI ဘလိတ်ဓါးဆူးကြိုး (Arrow Fish).png": 794,
	"./Galvanized GI ဘလိတ်ဓါးဆူးကြိုး (Single).png": 4079,
	"./Stainless Steel ဘလိတ်ဓါးဆူးကြိုး -304 Quality (Arrow Fish)).png": 3038,
	"./Stainless Steel ဘလိတ်ဓါးဆူးကြိုး -304 Quality (Single).png": 7650,
	"./Steel Coated ဘလိတ်ဓါးဆူးကြိုး -202 Quality (Arrow Fish)).png": 8663,
	"./Steel Coated ဘလိတ်ဓါးဆူးကြိုး -202 Quality (Single).png": 6029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9721;